import React from 'react';

function HealthBar({ current, max, color }) {
  const percentage = Math.max(0, Math.min(100, (current / max) * 100));

  // Round numbers to whole numbers
  const formatNumber = (num) => {
    return Math.round(num).toString();
  };

  const formattedCurrent = formatNumber(Math.max(0, current));
  const formattedMax = formatNumber(Math.max(1, max));

  return (
    <div className="health-bar">
      <div
        className="health-bar-fill"
        style={{ width: `${percentage}%`, backgroundColor: color }}
      />
      <p className="health-bar-text">
        {formattedCurrent}/{formattedMax}
      </p>
    </div>
  );
}

export default HealthBar;